"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$ = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$ = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema = void 0;
exports.getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurityToJSON = getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurityToJSON;
exports.getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurityFromJSON = getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurityFromJSON;
exports.getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequestToJSON = getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequestToJSON;
exports.getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequestFromJSON = getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$;
(function (GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$) {
    /** @deprecated use `GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema` instead. */
    GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$.inboundSchema = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema;
    /** @deprecated use `GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema` instead. */
    GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$.outboundSchema = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema;
})(GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$ || (exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$ = GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$ = {}));
function getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurityToJSON(getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity) {
    return JSON.stringify(exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema
        .parse(getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity));
}
function getPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertiesStatsPropertiesStreetGroupPropertyIdGetSecurity' from JSON`);
}
/** @internal */
exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
    street_group_property_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
    streetGroupPropertyId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$;
(function (GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$) {
    /** @deprecated use `GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema` instead. */
    GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$.inboundSchema = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema;
    /** @deprecated use `GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema` instead. */
    GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$.outboundSchema = exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema;
})(GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$ || (exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$ = GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$ = {}));
function getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequestToJSON(getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest) {
    return JSON.stringify(exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema
        .parse(getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest));
}
function getPropertiesStatsPropertiesStreetGroupPropertyIdGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertiesStatsPropertiesStreetGroupPropertyIdGetRequest' from JSON`);
}
//# sourceMappingURL=getpropertiesstatspropertiesstreetgrouppropertyidget.js.map